module.exports = __webpack_public_path__ + "static/images/cover_A2.5b70532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_A2.png
// module id = gH9N
// module chunks = 8